import React from "react";
import { InputFactory as Factory, RelatedFactory } from "../../nq-component";
import { findObjectUseCase, saveObjectUseCase } from "../../usecases/object";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";
import Context from "../../AppContext";
import InputRelation from "../InputRelation";
import InputPointer from "../InputPointer";
import InputFileMultiple from "../InputMultipleFile";
import InputCamera from "../InputCamera";
import FileInput from "../InputTypeFile";
import InputText from "../InputText";

const defaultProps = {};

function InputFactory({ type, _type, field, object, onChange, ...props }) {
  const context = React.useContext(Context);
  const value = object && object[field];

  function _onChange(field, value) {
    if (object) {
      object[field] = value;
    }
    onChange(value, field);
  }

  switch (_type || type) {
    case "Related":
      return (
        <RelatedFactory
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            context.schemas?.find((s) => s.collection === props.target)
          }
          schemas={context.schemas}
          field={field}
          {...props}
        />
      );
    case "Relation":
      return (
        <InputRelation
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={props?.schemas?.find((s) => s.collection === props.target)}
          schemas={props?.schemas}
          // required={_required || required}
          {...props}
        />
      );
    case "ClientPointer":
      const schema = props.schemas.find((s) => s.collection === props.target);
      if (!schema) return null;
      return (
        <InputPointer
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            props.schemas?.find((s) => s.collection === props.target)
          }
          findObject={findObjectUseCase()}
          schemas={props.schemas}
          // required={_required || required}
          {...props}
        />
      );
    case "RecruiterPointer":
      const schemar = props.schemas?.find((s) => s.collection === props.target);

      if (!schemar) return null;
      return (
        <InputPointer
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema ||
            props.schemas?.find((s) => s.collection === props.target)
          }
          findObject={findObjectUseCase()}
          schemas={props.schemas}
          // required={_required || required}
          {...props}
        />
      );
    case "MultipleFile":
    case "InputFile":
      return (
        <InputFileMultiple
          value={value}
          onChange={_onChange.bind(this, field)}
          // required={_required || required}
          {...props}
        />
      );
    case "InputCamera":
      return (
        <InputCamera
          className="form-control"
          onChange={_onChange.bind(this, field)}
          object={value}
          {...props}
        />
      );
    case "File":
      return (
        <FileInput
          className="form-control"
          saveFile={saveFileUseCase()}
          onChange={_onChange.bind(this, field)}
          object={value}
          {...props}
        />
      );
    case "Text":
    case "InputText":
      return (
        <InputText
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          {...props}
        />
      );
    default:
      return (
        <Factory
          type={type}
          _type={_type}
          field={field}
          object={object}
          schemas={context.schemas}
          onChange={onChange}
          findObject={findObjectUseCase()}
          saveObject={saveObjectUseCase()}
          saveImage={saveImageUseCase()}
          saveFile={saveFileUseCase()}
          {...props}
        />
      );
  }
}

InputFactory.defaultProps = defaultProps;
export default InputFactory;
